import { render } from "./recommend.vue?vue&type=template&id=07896030&scoped=true"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"

import "./recommend.vue?vue&type=style&index=0&id=07896030&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07896030"

export default script